<template>
    <div class="form-group"
        v-bind:class="{ 'dark': this.getDesign() == 'black', 'white': this.getDesign() == 'white' }">
        <label for="paymentMethod">{{ $t('Método de pago') }}</label>
        <select v-model="paymentMethodSelected" name="paymentMethod" id="paymentMethod" @change="changePaymentMethod">
            <option v-for="(paymentMethod, index) in paymentMethods" :value="index" v-bind:key="index">{{
                paymentMethod.name }}</option>
        </select>
    </div>
</template>

<script>

import { mapGetters } from 'vuex';

import api from '@/api';

export default {
    extends: api,
    name: "payment-methods",
    props: ["callSunday"],
    computed: {
        ...mapGetters(['getDesign', 'getPaymentMethods', 'getDateSelected', 'getCheckout']),
    },
    data() {
        return {
            paymentMethodSelected: 0,
            paymentMethods: []
        }
    },
    created() {
        this.getPaymentMethodsCall();
    },
    methods: {
        getPaymentMethodsCall: async function () {
            if (!this.getCheckout().id) {
                /*
           Para evitar que se llame más de una vez 
           el método solo se llama si se ha
           aceptado terminos y considicones
           */
                return;
            }

            const paymentIds = this.getPaymentMethods().split(',');

            const paymentMetods = await new Promise((resolve) => {
                this.getPaymentMethodsApi(paymentIds, resolve);
            });

            paymentMetods.forEach((payment) => {
                /* Si tenemos callSundays activado, el día seleccionado es domingo -> solo vamos a meter en el array in_local_payment*/
                let dateSelected = this.getDateSelected().split('/');
                let dateSelectedDate = new Date(dateSelected[2], dateSelected[1] - 1, dateSelected[0], 0);

                /* Si tenemos callSundays activado */
                if (this.$props.callSunday) {
                    /* Si el día seleccionado es Domingo, */
                    if (dateSelectedDate.getDay() === 0) {
                        /* Solo añadimos al array in_local_payment*/
                        if (payment.type == 'in_local_payment') {
                            this.paymentMethods = [];
                            this.paymentMethods.push(payment);
                        }
                    }
                    /* Si no es Domingo, añadimos al array todos menos in_local_payment*/
                    else if (payment.type != 'in_local_payment') {
                        this.paymentMethods.push(payment);
                    }
                }
                else {
                    this.paymentMethods.push(payment);
                }
                this.changePaymentMethod();
            });
        },
        changePaymentMethod: function () {
            if (this.getCheckout().id) {
                const payment = this.paymentMethods[this.paymentMethodSelected];
                this.$emit('change-payment-method', { paymentMethodId: payment.id, paymentMethodType: payment.type });
            }
        },
    }
}
</script>
